module.exports = __webpack_public_path__ + "static/media/liftup-default-1.c02f335d.jpg";